export const locale = {
    lang: "es",
    data: {
        CHARTS: {
            Title: "Gráficos",
            ChartConfiguration: "Configuración del gráfico",
            SeriesConfiguration: "Configuración de series",
            Devices: "Dispositivos",
            DataPoint: "Dato",
            Series: "Series",
            Device: "Dispositivo",
            Actions: "Acciones",
            AddSeries: "Añadir serie",
            AddButton: "Añadir",
            RemoveButton: "Quitar",
            DevicesHint: "Elige un dispositivo del proyecto actual.",
            DataPointHint: "Selecciona la métrica que quieres añadir al gráfico, incluyendo series L10/L90.",
            NoProjectSelected: "Selecciona primero un proyecto para comparar datos.",
            NoDevicesAvailable: "No hay dispositivos disponibles en el proyecto actual.",
            NoSeriesSelected: "Añade al menos un dispositivo y un dato para mostrar el gráfico.",
            NoChartData: "No hay datos disponibles para la configuración actual.",
        },
    },
};
